import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VIEWS } from '@go-modules/enums/views';
import type { Activity } from '@go-modules/interfaces/activity';
import { ViewStateDataSource } from '@go-modules/services/view-state-datasource/view-state.datasource';
import { TranslateModule } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { Observable } from 'rxjs';

@Component({
	selector: 'ngx-activity-due-date',
	templateUrl: './activity-due-date.component.html',
	styleUrls: ['./activity-due-date.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		TranslateModule,
		MatTooltipModule,
		DatePipe,
		AsyncPipe,
		NgClass
	]
})
export class NgxActivityDueDateComponent implements OnInit {
	@Input() public date: any;
	@Input() public activity: Activity;
	@Input() public withDateLabel: boolean = true;

	public readonly views = VIEWS;
	public currentView$: Observable<VIEWS>;

	constructor (
		public viewStateDataSource: ViewStateDataSource,
		@Inject(selectedServiceToken) public selectedService: SelectedService
	) {}

	public ngOnInit (): void {
		this.currentView$ = this.viewStateDataSource.viewState$;
	}

	public isPastDue (): boolean {
		const dueAt = dayjs.utc(this.activity.due_at);
		const nowUtc = dayjs.utc();

		if (this.selectedService.getGroup().hasReviewerRole(true)) {
			return nowUtc.isAfter(dueAt) && this.activity.has_late_submissions;
		}

		return nowUtc.isAfter(dueAt) && this.activity.have_i_submitted === false;
	}

	public getTooltipStr (): string {
		if (this.selectedService.getGroup().hasReviewerRole(true)) {
			return 'activity-list_due-late-tooltip-instructor';
		}

		return 'activity-list_due-late-tooltip-student';
	}
}
